import {
    HttpModel,
    PaginationModel,
    TableHeadersModel,
} from '@/Shared/domain'
import { useBackendTable } from '@/Shared/ui/Table'
import { accessRolesTranslation } from '../AccesRolesTranslation'
import { AccessRolesModel } from '@/AccessRoles/domain'
import { AccessRolesContract } from '@/AccessRoles/application/AccesRoles'
import { createApiAccessRolesRepository } from '@/AccessRoles/infrastructure/ApiAccessRolesRepository'

export interface IUseAccessRoles {
    profiles?: AccessRolesModel[]
    numberOfRecordsPerPage: number
    page: number
    count: number
    onPageChange: (page: number) => void
    tableHeaders: TableHeadersModel[]
}

export const useAccessRoles = (): IUseAccessRoles => {

    const tableHeaders: TableHeadersModel[] = [
        {
            key: 'name',
            label: accessRolesTranslation.table.header.name,
            size: 'auto',
        },
        {
            key: 'email',
            label: accessRolesTranslation.table.header.email,
            size: 'auto',
        },
        {
            key: 'status',
            label: accessRolesTranslation.table.header.status,
            size: 'auto',
        },
        {
            key: 'profile',
            label: accessRolesTranslation.table.header.profile,
            size: 'auto',
        },
        {
            key: 'actions',
            label: accessRolesTranslation.table.header.actions,
            size: 'auto',
        },
    ]

    const loadAccessRoles = async (): Promise<HttpModel<PaginationModel<AccessRolesModel>>> => {
        
        const repository = createApiAccessRolesRepository()
        
        return AccessRolesContract(repository).getAccessRoles(page, itemsPerPage)
    }

    const { items, loadItems, itemsPerPage, page,  ...rest } = useBackendTable<AccessRolesModel>(
        loadAccessRoles,
        undefined,
    )

    return {
        profiles: items,
        tableHeaders,
        numberOfRecordsPerPage: itemsPerPage,
        page, 
        ...rest
    }
}